document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('[data-infinite-scroll="true"]');
  const grid = document.querySelector('#product-grid');
  const loader = document.getElementById('CollectionInfiniteLoader');

  if (!container || !grid || !loader) return;

  let isLoading = false;
  let currentPage = Number(container.dataset.currentPage || 1);
  const maxPages = Number(container.dataset.maxPages || 1);
  const sectionId = container.dataset.sectionId;
  const collectionUrl = window.location.pathname.split('?')[0];

  // Hide loader if no more pages exist
  if (maxPages <= 1) {
    loader.style.display = 'none';
    return;
  }

  function showLoader() {
    loader.classList.add('is-active');
  }

  function hideLoader() {
    loader.classList.remove('is-active');
  }

  async function loadNextPage() {
    if (isLoading || currentPage >= maxPages) {
      hideLoader();
      return;
    }

    isLoading = true;
    showLoader();

    const nextPage = currentPage + 1;
    const url = `${collectionUrl}?page=${nextPage}&section_id=${sectionId}`;

    try {
      const res = await fetch(url);
      const html = await res.text();

      const temp = document.createElement('div');
      temp.innerHTML = html;

      const newGrid = temp.querySelector('#product-grid');
      if (newGrid) {
        const newItems = newGrid.querySelectorAll('li.grid__item, li');
        newItems.forEach(item => grid.appendChild(item));
      }

      currentPage = nextPage;

      if (currentPage >= maxPages) {
        hideLoader();
        loader.style.display = 'none';
        window.removeEventListener('scroll', handleScroll);
      } else {
        hideLoader();
      }

    } catch (e) {
      console.error('Infinite scroll error:', e);
      hideLoader();
    } finally {
      isLoading = false;
    }
  }

  function handleScroll() {
    if (isLoading || currentPage >= maxPages) return;

    const scrollTrigger = document.body.offsetHeight - 600;
    if (window.innerHeight + window.scrollY >= scrollTrigger) {
      loadNextPage();
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true });
});
